import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Grid, Input } from 'semantic-ui-react';

const SEARCH_FIELD_OPTIONS = [
  {
    key: 'registered_email',
    value: 'registered_email',
    text: 'Registered email',
  },
  { key: 'business_name', value: 'business_name', text: 'Business name' },
  { key: 'business_email', value: 'business_email', text: 'Business email' },
  { key: 'bid', value: 'business_id', text: 'BID' },
];

function ActionBar({ onSearch }) {
  const [searchBy, setSearchBy] = useState(SEARCH_FIELD_OPTIONS[0].value);
  const [searchValue, setSearchValue] = useState('');

  const onSearchByChanged = (e, { value }) => setSearchBy(value);
  const onSearchValueChanged = (e, { value }) => setSearchValue(value);
  const onSearchButtonClicked = () => onSearch({ searchBy, searchValue });
  const onSearchValueKeyPress = e => {
    if (e.key === 'Enter') {
      onSearchButtonClicked();
    }
  };

  return (
    <Grid>
      <Grid.Column width={4}>
        <Dropdown
          selection
          fluid
          options={SEARCH_FIELD_OPTIONS}
          value={searchBy}
          onChange={onSearchByChanged}
        />
      </Grid.Column>
      <Grid.Column width={8}>
        <Input
          fluid
          placeholder="Search value"
          value={searchValue}
          onChange={onSearchValueChanged}
          onKeyPress={onSearchValueKeyPress}
        />
      </Grid.Column>
      <Grid.Column width={4}>
        <Button primary onClick={onSearchButtonClicked}>
          Search
        </Button>
      </Grid.Column>
    </Grid>
  );
}

ActionBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default ActionBar;
